import { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import logoImg from '../assets/logo.png';

const LOGO_URL = (d) => `https://www.google.com/s2/favicons?domain=${d}&sz=64`;

const MARKETS = [
  { name: 'Amazon',     cat: 'PPC & Marketplace',   href: '/services/amazon',     logo: LOGO_URL('amazon.com') },
  { name: 'Shopify',    cat: 'E-Commerce & CRO',    href: '/services/shopify',    logo: LOGO_URL('shopify.com') },
  { name: 'Walmart',    cat: 'Marketplace & WFS',   href: '/services/walmart',    logo: LOGO_URL('walmart.com') },
  { name: 'Noon',       cat: 'Middle East',         href: '/services/noon',       logo: LOGO_URL('noon.com') },
  { name: 'eBay',       cat: 'Global Marketplace',  href: '/services/ebay',       logo: LOGO_URL('ebay.com') },
  { name: 'AliExpress', cat: 'International Sales', href: '/services/aliexpress', logo: LOGO_URL('aliexpress.com') },
  { name: 'Flipkart',   cat: 'Indian Marketplace',  href: '/services/flipkart',   logo: LOGO_URL('flipkart.com') },
  { name: 'Meesho',     cat: 'Social Commerce',     href: '/services/meesho',     logo: LOGO_URL('meesho.com') },
  { name: 'Myntra',     cat: 'Fashion',             href: '/services/myntra',     logo: LOGO_URL('myntra.com') },
  { name: 'Nykaa',      cat: 'Beauty & Wellness',   href: '/services/nykaa',      logo: LOGO_URL('nykaa.com') },
  { name: 'AJIO',       cat: 'Fashion & Lifestyle', href: '/services/ajio',       logo: LOGO_URL('ajio.com') },
  { name: 'Blinkit',    cat: 'Quick Commerce',      href: '/services/blinkit',    logo: LOGO_URL('blinkit.com') },
];

const AD_CHANNELS = [
  { name: 'Marketplace Ads', desc: 'Amazon · Shopify · Flipkart', logo: LOGO_URL('amazon.com') },
  { name: 'Meta Ads',        desc: 'Facebook & Instagram',        logo: LOGO_URL('meta.com') },
  { name: 'Google Ads',      desc: 'Search & Display',            logo: LOGO_URL('google.com') },
];

const WEB_DEV_SERVICES = [
  {
    name: 'E-commerce Stores', desc: 'Shopify · WooCommerce', color: '#10b981',
    icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>,
  },
  {
    name: 'Portfolio Websites', desc: 'Personal · Agency · Creative', color: '#8b5cf6',
    icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/></svg>,
  },
  {
    name: 'Custom CMS', desc: 'WordPress · Headless · Custom', color: '#3b82f6',
    icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>,
  },
  {
    name: 'Custom CRM', desc: 'Sales Pipelines · Operations', color: '#f59e0b',
    icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  },
  {
    name: 'SaaS & Web Apps', desc: 'Dashboards · Platforms', color: '#ef4444',
    icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>,
  },
  {
    name: 'Landing Pages', desc: 'Lead Gen · Conversion Funnels', color: '#ec4899',
    icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>,
  },
  {
    name: 'Corporate Websites', desc: 'B2B · Enterprise · Business', color: '#0ea5e9',
    icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
  },
  {
    name: 'Progressive Web Apps', desc: 'Fast · Offline-ready · PWA', color: '#14b8a6',
    icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="5" y="2" width="14" height="20" rx="2" ry="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>,
  },
];

// Desktop: Home + Our Story appear BEFORE the dropdowns
const NAV_BEFORE = [
  { label: 'Home',      hash: 'home', href: '/',      num: '01' },
  { label: 'Our Story', hash: null,   href: '/about', num: '02' },
];

// Desktop: Blog appears AFTER the dropdowns
const NAV_AFTER = [
  { label: 'Blog', hash: null, href: '/blog', num: '06' },
];

const HEADER_HEIGHT = 68;

export default function Header() {
  const [scrolled,       setScrolled]       = useState(false);
  const [menuOpen,       setMenuOpen]       = useState(false);
  const [marketsOpen,    setMarketsOpen]    = useState(false);
  const [advOpen,        setAdvOpen]        = useState(false);
  const [webDevOpen,     setWebDevOpen]     = useState(false);
  const [sbMarketsOpen,  setSbMarketsOpen]  = useState(false);
  const [sbAdvOpen,      setSbAdvOpen]      = useState(false);
  const [sbWebDevOpen,   setSbWebDevOpen]   = useState(false);
  const marketsTimer = useRef(null);
  const advTimer     = useRef(null);
  const webDevTimer  = useRef(null);
  const location = useLocation();
  const isHome = location.pathname === '/';
  const showBackground = scrolled || !isHome;

  const activeLabel = (() => {
    if (location.pathname === '/blog')                           return 'Blog';
    if (location.pathname === '/services/performance-marketing') return 'Advertisement';
    if (location.pathname === '/services/web-development')       return 'Web Development';
    if (location.pathname === '/careers')                        return 'Careers';
    if (location.pathname === '/contact')                        return 'Contact';
    if (location.pathname === '/')                               return 'Home';
    return null;
  })();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  useEffect(() => {
    setMarketsOpen(false);
    setAdvOpen(false);
    setWebDevOpen(false);
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    return () => {
      if (marketsTimer.current) clearTimeout(marketsTimer.current);
      if (advTimer.current)     clearTimeout(advTimer.current);
      if (webDevTimer.current)  clearTimeout(webDevTimer.current);
    };
  }, []);

  const handleMarketsEnter = () => {
    if (marketsTimer.current) clearTimeout(marketsTimer.current);
    if (advTimer.current)     clearTimeout(advTimer.current);
    if (webDevTimer.current)  clearTimeout(webDevTimer.current);
    setAdvOpen(false);
    setWebDevOpen(false);
    setMarketsOpen(true);
  };
  const handleMarketsLeave = () => {
    marketsTimer.current = setTimeout(() => setMarketsOpen(false), 60);
  };

  const handleAdvEnter = () => {
    if (advTimer.current) clearTimeout(advTimer.current);
    if (marketsTimer.current) clearTimeout(marketsTimer.current);
    if (webDevTimer.current)  clearTimeout(webDevTimer.current);
    setMarketsOpen(false);
    setWebDevOpen(false);
    setAdvOpen(true);
  };
  const handleAdvLeave = () => {
    advTimer.current = setTimeout(() => setAdvOpen(false), 60);
  };

  const handleWebDevEnter = () => {
    if (webDevTimer.current)  clearTimeout(webDevTimer.current);
    if (marketsTimer.current) clearTimeout(marketsTimer.current);
    if (advTimer.current)     clearTimeout(advTimer.current);
    setMarketsOpen(false);
    setAdvOpen(false);
    setWebDevOpen(true);
  };
  const handleWebDevLeave = () => {
    webDevTimer.current = setTimeout(() => setWebDevOpen(false), 60);
  };

  const handleNav = (e, hash) => {
    if (hash) {
      const el = document.getElementById(hash);
      if (el) {
        e.preventDefault();
        const top = el.getBoundingClientRect().top + window.scrollY - HEADER_HEIGHT;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    }
    setMenuOpen(false);
    setMarketsOpen(false);
    setAdvOpen(false);
    setWebDevOpen(false);
  };

  const closeAll = () => {
    setMenuOpen(false);
    setMarketsOpen(false);
    setAdvOpen(false);
    setWebDevOpen(false);
  };

  const navLink = ({ label, hash, href }) => (
    <a
      key={label}
      href={isHome && hash ? `#${hash}` : href}
      className={`hdr-nav__link${activeLabel === label ? ' hdr-nav__link--active' : ''}`}
      onClick={(e) => handleNav(e, isHome ? hash : null)}
    >
      {label}
    </a>
  );

  return (
    <>
      <header className={`hdr${showBackground ? ' hdr--scrolled' : ''}`}>
        <div className="hdr-inner">

          {/* Logo */}
          <Link to="/" className="hdr-logo" aria-label="Home">
            <img src={logoImg} alt="MMC Logo" className="hdr-logo__img" />
          </Link>

          {/* Center nav — order: Home | Our Story | Marketplaces▾ | Advertisement▾ | Web Dev▾ | Blog | Careers */}
          <div className="hdr-nav-center">

            {/* Home, Our Story */}
            {NAV_BEFORE.map(navLink)}

            {/* Marketplaces mega dropdown */}
            <div
              className="hdr-markets-wrap"
              onMouseEnter={handleMarketsEnter}
              onMouseLeave={handleMarketsLeave}
            >
              <button
                type="button"
                className={`hdr-nav__link hdr-markets-btn${location.pathname.startsWith('/services') && location.pathname !== '/services/performance-marketing' && location.pathname !== '/services/web-development' ? ' hdr-nav__link--active' : ''}`}
                onClick={() => { setAdvOpen(false); setMarketsOpen(o => !o); }}
                aria-expanded={marketsOpen}
                aria-haspopup="true"
              >
                Marketplaces
                <svg
                  className="hdr-markets-chevron"
                  width="10" height="10" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" strokeWidth="2.8"
                  strokeLinecap="round" strokeLinejoin="round"
                  style={{ transform: marketsOpen ? 'rotate(180deg)' : 'rotate(0)' }}
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </button>

              <div
                className={`hdr-dropdown${marketsOpen ? ' hdr-dropdown--open' : ''}`}
                role="menu"
                onMouseEnter={handleMarketsEnter}
                onMouseLeave={handleMarketsLeave}
              >
                <div className="hdr-dropdown__head">
                  <span className="hdr-dropdown__title">Our Marketplaces</span>
                  <a href="/#services" className="hdr-dropdown__view-all" onClick={closeAll}>
                    View All
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
                    </svg>
                  </a>
                </div>
                <div className="hdr-dropdown__grid">
                  {MARKETS.map(m => (
                    <Link key={m.name} to={m.href} className="hdr-dd-item" role="menuitem" onClick={closeAll}>
                      <img src={m.logo} alt={m.name} className="hdr-dd-logo" />
                      <div className="hdr-dd-text">
                        <div className="hdr-dd-name">{m.name}</div>
                        <div className="hdr-dd-cat">{m.cat}</div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>

            {/* Advertisement dropdown */}
            <div
              className="hdr-adv-wrap"
              onMouseEnter={handleAdvEnter}
              onMouseLeave={handleAdvLeave}
            >
              <button
                type="button"
                className={`hdr-nav__link hdr-adv-btn${activeLabel === 'Advertisement' ? ' hdr-nav__link--active' : ''}`}
                onClick={() => { setMarketsOpen(false); setAdvOpen(o => !o); }}
                aria-expanded={advOpen}
                aria-haspopup="true"
              >
                Advertisement
                <svg
                  className="hdr-markets-chevron"
                  width="10" height="10" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" strokeWidth="2.8"
                  strokeLinecap="round" strokeLinejoin="round"
                  style={{ transform: advOpen ? 'rotate(180deg)' : 'rotate(0)' }}
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </button>

              <div
                className={`hdr-adv-dropdown${advOpen ? ' hdr-adv-dropdown--open' : ''}`}
                role="menu"
                onMouseEnter={handleAdvEnter}
                onMouseLeave={handleAdvLeave}
              >
                <div className="hdr-dropdown__head">
                  <span className="hdr-dropdown__title">Ad Channels</span>
                </div>
                <div className="hdr-adv-list">
                  {AD_CHANNELS.map(ch => (
                    <Link
                      key={ch.name}
                      to="/services/performance-marketing"
                      className="hdr-adv-item"
                      role="menuitem"
                      onClick={closeAll}
                    >
                      <img src={ch.logo} alt={ch.name} className="hdr-dd-logo" />
                      <div className="hdr-dd-text">
                        <div className="hdr-dd-name">{ch.name}</div>
                        <div className="hdr-dd-cat">{ch.desc}</div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>

            {/* Web Development dropdown */}
            <div
              className="hdr-webdev-wrap"
              onMouseEnter={handleWebDevEnter}
              onMouseLeave={handleWebDevLeave}
            >
              <button
                type="button"
                className={`hdr-nav__link hdr-webdev-btn${activeLabel === 'Web Development' ? ' hdr-nav__link--active' : ''}`}
                onClick={() => { setMarketsOpen(false); setAdvOpen(false); setWebDevOpen(o => !o); }}
                aria-expanded={webDevOpen}
                aria-haspopup="true"
              >
                Web Dev
                <svg
                  className="hdr-markets-chevron"
                  width="10" height="10" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" strokeWidth="2.8"
                  strokeLinecap="round" strokeLinejoin="round"
                  style={{ transform: webDevOpen ? 'rotate(180deg)' : 'rotate(0)' }}
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </button>

              <div
                className={`hdr-webdev-dropdown${webDevOpen ? ' hdr-webdev-dropdown--open' : ''}`}
                role="menu"
                onMouseEnter={handleWebDevEnter}
                onMouseLeave={handleWebDevLeave}
              >
                <div className="hdr-dropdown__head">
                  <span className="hdr-dropdown__title">Web Development</span>
                  <Link to="/services/web-development" className="hdr-dropdown__view-all" onClick={closeAll}>
                    View All
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
                    </svg>
                  </Link>
                </div>
                <div className="hdr-webdev-grid">
                  {WEB_DEV_SERVICES.map(item => (
                    <Link
                      key={item.name}
                      to="/services/web-development"
                      className="hdr-webdev-item"
                      role="menuitem"
                      onClick={closeAll}
                    >
                      <span className="hdr-webdev-icon" style={{ background: item.color + '1a', color: item.color }}>
                        {item.icon}
                      </span>
                      <div className="hdr-dd-text">
                        <div className="hdr-dd-name">{item.name}</div>
                        <div className="hdr-dd-cat">{item.desc}</div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>

            {/* Blog */}
            {NAV_AFTER.map(navLink)}

            {/* Careers — last */}
            <a
              href="/careers"
              className={`hdr-nav__link${activeLabel === 'Careers' ? ' hdr-nav__link--active' : ''}`}
              onClick={(e) => handleNav(e, null)}
            >
              Careers
            </a>
          </div>

          {/* Actions */}
          <div className="hdr-actions">
            <Link
              to="/contact"
              className={`hdr-contact-btn${activeLabel === 'Contact' ? ' hdr-contact-btn--active' : ''}`}
              onClick={closeAll}
            >
              Contact
            </Link>
            <button
              className={`hdr-burger${menuOpen ? ' hdr-burger--open' : ''}`}
              onClick={() => setMenuOpen(o => !o)}
              aria-label="Toggle menu"
            >
              <span /><span /><span />
            </button>
          </div>
        </div>
      </header>

      {/* Overlay */}
      <div
        className={`hdr-sb-overlay${menuOpen ? ' hdr-sb-overlay--on' : ''}`}
        onClick={() => setMenuOpen(false)}
      />

      {/* Mobile sidebar — order: Home | Our Story | Marketplaces | Advertisement | Web Dev | Blog | Careers */}
      <aside className={`hdr-sb${menuOpen ? ' hdr-sb--open' : ''}`} aria-hidden={!menuOpen}>
        <div className="hdr-sb__head">
          <img src={logoImg} alt="Logo" className="hdr-sb__logo" />
          <button className="hdr-sb__close" onClick={() => setMenuOpen(false)} aria-label="Close menu">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <nav className="hdr-sb__nav">

          {/* Home, Our Story */}
          {NAV_BEFORE.map(({ label, hash, href, num }) => (
            <a
              key={label}
              href={isHome && hash ? `#${hash}` : href}
              className={`hdr-sb__link${activeLabel === label ? ' hdr-sb__link--active' : ''}`}
              onClick={(e) => handleNav(e, isHome ? hash : null)}
            >
              <span className="hdr-sb__num">{num}</span>
              <span className="hdr-sb__label">{label}</span>
              <svg className="hdr-sb__arrow" width="15" height="15" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
          ))}

          {/* Marketplaces — 03 */}
          <div className="hdr-sb__markets-section">
            <button
              type="button"
              className={`hdr-sb__link hdr-sb__markets-toggle${sbMarketsOpen ? ' hdr-sb__markets-toggle--open' : ''}`}
              onClick={() => setSbMarketsOpen(o => !o)}
            >
              <span className="hdr-sb__num">03</span>
              <span className="hdr-sb__label">Marketplaces</span>
              <svg
                className="hdr-sb__chevron"
                width="14" height="14" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" strokeWidth="2.5"
                strokeLinecap="round" strokeLinejoin="round"
                style={{ transform: sbMarketsOpen ? 'rotate(180deg)' : 'rotate(0)' }}
              >
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>

            {sbMarketsOpen && (
              <div className="hdr-sb__markets-list">
                {MARKETS.map(m => (
                  <Link key={m.name} to={m.href} className="hdr-sb__market-link"
                    onClick={() => setMenuOpen(false)}>
                    <img src={m.logo} alt={m.name} className="hdr-sb__market-logo" />
                    <div>
                      <div className="hdr-sb__market-name">{m.name}</div>
                      <div className="hdr-sb__market-cat">{m.cat}</div>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>

          {/* Advertisement — 04 */}
          <div className="hdr-sb__markets-section">
            <button
              type="button"
              className={`hdr-sb__link hdr-sb__markets-toggle${sbAdvOpen ? ' hdr-sb__markets-toggle--open' : ''}`}
              onClick={() => setSbAdvOpen(o => !o)}
            >
              <span className="hdr-sb__num">04</span>
              <span className="hdr-sb__label">Advertisement</span>
              <svg
                className="hdr-sb__chevron"
                width="14" height="14" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" strokeWidth="2.5"
                strokeLinecap="round" strokeLinejoin="round"
                style={{ transform: sbAdvOpen ? 'rotate(180deg)' : 'rotate(0)' }}
              >
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>

            {sbAdvOpen && (
              <div className="hdr-sb__markets-list">
                {AD_CHANNELS.map(ch => (
                  <Link
                    key={ch.name}
                    to="/services/performance-marketing"
                    className="hdr-sb__market-link"
                    onClick={() => setMenuOpen(false)}
                  >
                    <img src={ch.logo} alt={ch.name} className="hdr-sb__market-logo" />
                    <div>
                      <div className="hdr-sb__market-name">{ch.name}</div>
                      <div className="hdr-sb__market-cat">{ch.desc}</div>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>

          {/* Web Development — 05 */}
          <div className="hdr-sb__markets-section">
            <button
              type="button"
              className={`hdr-sb__link hdr-sb__markets-toggle${sbWebDevOpen ? ' hdr-sb__markets-toggle--open' : ''}`}
              onClick={() => setSbWebDevOpen(o => !o)}
            >
              <span className="hdr-sb__num">05</span>
              <span className="hdr-sb__label">Web Development</span>
              <svg
                className="hdr-sb__chevron"
                width="14" height="14" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" strokeWidth="2.5"
                strokeLinecap="round" strokeLinejoin="round"
                style={{ transform: sbWebDevOpen ? 'rotate(180deg)' : 'rotate(0)' }}
              >
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>

            {sbWebDevOpen && (
              <div className="hdr-sb__markets-list">
                {WEB_DEV_SERVICES.map(item => (
                  <Link
                    key={item.name}
                    to="/services/web-development"
                    className="hdr-sb__market-link"
                    onClick={() => setMenuOpen(false)}
                  >
                    <span className="hdr-webdev-sb-icon" style={{ background: item.color + '20', color: item.color }}>
                      {item.icon}
                    </span>
                    <div>
                      <div className="hdr-sb__market-name">{item.name}</div>
                      <div className="hdr-sb__market-cat">{item.desc}</div>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>

          {/* Blog — 06 */}
          {NAV_AFTER.map(({ label, hash, href, num }) => (
            <a
              key={label}
              href={isHome && hash ? `#${hash}` : href}
              className={`hdr-sb__link${activeLabel === label ? ' hdr-sb__link--active' : ''}`}
              onClick={(e) => handleNav(e, isHome ? hash : null)}
            >
              <span className="hdr-sb__num">{num}</span>
              <span className="hdr-sb__label">{label}</span>
              <svg className="hdr-sb__arrow" width="15" height="15" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
          ))}

          {/* Careers — 07 */}
          <a
            href="/careers"
            className={`hdr-sb__link${activeLabel === 'Careers' ? ' hdr-sb__link--active' : ''}`}
            onClick={(e) => handleNav(e, null)}
          >
            <span className="hdr-sb__num">07</span>
            <span className="hdr-sb__label">Careers</span>
            <svg className="hdr-sb__arrow" width="15" height="15" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </a>
        </nav>

        <div className="hdr-sb__footer">
          <Link
            to="/contact"
            className="hdr-sb__cta"
            onClick={() => setMenuOpen(false)}
          >
            Get in Touch
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </Link>
        </div>
      </aside>
    </>
  );
}
